import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=56042f5e&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=56042f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56042f5e",
  null
  
)

export default component.exports